import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { urlEndPoint } from 'src/app/common';
import { Message } from 'src/app/models/message';
import { Tier3 } from 'src/app/models/obs/tier3';
import { DptoService } from 'src/app/services/obs/dpto.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';
import { ResponseOneTier3, ResponseSignalPeriod, ResponseSignalQuadrant, ResponseTematic, ResponseTier3, ResponseTier3Relations } from 'src/app/models/obs/apiResponse';
import { Tematic } from 'src/app/models/obs/tematic';
import { SignalPeriod } from 'src/app/models/obs/signalPeriod';
import { ErrorHandlingService } from 'src/app/services/util/error-handling.service';
import { SignalQuadrantService } from 'src/app/services/obs/signal-quadrant.service';
import { SignalQuadrant } from 'src/app/models/obs/signalQuadrant';
import { Tier3RelationsService } from 'src/app/services/obs/tier3-relations.service';
import { Tier3Relations } from 'src/app/models/obs/Tier3Relations';
import { Observable, forkJoin, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UploadfileService } from 'src/app/services/util/uploadfile.service';
import { UserLogService } from 'src/app/services/user-log.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { TematicService } from 'src/app/services/obs/tematic.service';
import { SignalPeriodService } from 'src/app/services/obs/signal-period.service';
import { Section } from 'src/app/models/obs/section';
import { SectionService } from 'src/app/services/obs/section.service';
import { Log } from 'src/app/models/user-log';
import { UtilLogService } from 'src/app/services/util/util-log.service';

@Component({
  selector: 'app-admsignal-form',
  templateUrl: './admsignal-form.component.html',
  styleUrl: './admsignal-form.component.scss'
})
export class AdmsignalFormComponent implements OnInit {

  formT3: FormGroup;
  t3: Tier3 = null;
  msg: Message;

  edit: boolean = false;
  idtier1: string = null;
  uploatedFile: File = null;
  filename: string = '';
  isUploadDir: boolean = false;

  URL: string = urlEndPoint;
  paramsTier1: string = null;
  paramsId: string = null;
  tags: string = null;

  tematics: Tematic[];
  periods: SignalPeriod[] = [];
  quadrants: SignalQuadrant[] = [];
  tier3Relations: Tier3Relations[] = [];
  risks: Tier3[] = [];
  opportunities: Tier3[] = [];

  showDeleteConfirmationRisk = false;
  showDeleteConfirmationOpp = false;
  riskToDelete: number;
  riskOne: Tier3 = null;
  oppToDelete: number;
  oppOne: Tier3 = null;

  idRisk: number = 6;
  idOpportunity: number = 4;

  movesLog: Log[] = null;
  codeValidationMessage: string | null = null;

  constructor(
    private secS: SectionService,
    private router: Router,
    private tier3Service: Tier3Service,
    private tier3RelationsService: Tier3RelationsService,
    private fb: FormBuilder,
    private activedRoute: ActivatedRoute,
    private uploadS: UploadfileService,
    private userLogService: UserLogService,
    private utilLogservice: UtilLogService,
    private tokenStorage: TokenStorageService,
    private tematicsService: TematicService,
    private periodService: SignalPeriodService,
    private quadrantService: SignalQuadrantService,
    private errorService: ErrorHandlingService) { }

  ngOnInit() {
    this.getQuadrants();
    this.getPeriods();
    this.getTematics();
    this.getRisksByIdTier1(this.idRisk);
    this.getOpportunitiesByIdTier1(this.idOpportunity);
    this.createForm();
    this.paramsTier1 = this.activedRoute.snapshot.params['idtier1'];
    this.getT3(this.activedRoute.snapshot.params);
  }

  getPeriods() {
    this.periodService.getAll().subscribe({
      next: async ({ data }: ResponseSignalPeriod) => { this.periods = data; },
      error: err => { this.msg = this.errorService.handleError(err); }
    });
  }

  getQuadrants() {
    this.quadrantService.getAll().subscribe({
      next: async ({ data }: ResponseSignalQuadrant) => { this.quadrants = data; },
      error: err => { this.msg = this.errorService.handleError(err); }
    });
  }

  getTier3Relations(id: number) {
    this.tier3RelationsService.getByTier3(id).subscribe({
      next: ({ data }: ResponseTier3Relations) => {
        this.t3.selectedRisks = data.filter(item => item.idtier1 === this.idRisk);
        this.t3.selectedOpps = data.filter(item => item.idtier1 === this.idOpportunity);

        const observablesArrayRisks: Observable<Tier3>[] = [];
        const observablesArrayOpps: Observable<Tier3>[] = [];

        this.t3.selectedRisks.forEach(risk => {
          observablesArrayRisks.push(this.getOneTier3ById(risk));
        });

        this.t3.selectedOpps.forEach(opp => {
          observablesArrayOpps.push(this.getOneTier3ById(opp));
        });

        forkJoin(observablesArrayRisks).subscribe(modifiedRisks => {
          const selectedRisksArray = this.fb.array([]);
          modifiedRisks.forEach(risk => {
            selectedRisksArray.push(this.fb.control(risk));
          });
          this.formT3.setControl('selectedRisks', selectedRisksArray);
        });

        forkJoin(observablesArrayOpps).subscribe(modifiedOpps => {
          const selectedOppsArray = this.fb.array([]);
          modifiedOpps.forEach(opp => {
            selectedOppsArray.push(this.fb.control(opp));
          });
          this.formT3.setControl('selectedOpps', selectedOppsArray);
        });

        this.loadDataTier3Relations();
      },
      error: err => { this.msg = this.errorService.handleError(err); }
    });
  }

  getOneTier3ById(tier3: Tier3Relations): Observable<Tier3> {
    return this.tier3Service.getOne(tier3.idtier3related).pipe(
      map(({ data }: ResponseOneTier3) => {
        tier3.shorttitle = data.shorttitle;
        return tier3;
      }),
      catchError(err => {
        this.msg = this.errorService.handleError(err);
        return throwError(err);
      })
    );
  }

  getRisksByIdTier1(id: number) {
    this.tier3Service.getByIdTier1(id).subscribe({
      next: async ({ data }: ResponseTier3) => { this.risks = data; },
      error: err => { this.msg = this.errorService.handleError(err); }
    });
  }

  getOpportunitiesByIdTier1(id: number) {
    this.tier3Service.getByIdTier1(id).subscribe({
      next: async ({ data }: ResponseTier3) => { this.opportunities = data; },
      error: err => { this.msg = this.errorService.handleError(err); }
    });
  }

  createForm() {
    this.formT3 = this.fb.group({
      id: [null],
      idtier1: [null],
      iddpto: [null],
      idtematic: ['', Validators.required],
      code: [{ value: '', disabled: this.edit }, Validators.required],
      version: ['', Validators.required],
      shorttitle: ['', Validators.required],
      longtitle: ['', Validators.required],
      summary: ['', Validators.required],
      detail: [null],
      publication: ['', Validators.required],
      img: [null],
      urlfile: [null],
      lastUpdated: ['', Validators.required],
      status: [],
      idquadrant: [],
      idperiod: [],
      tags: [],
      angle: [],
      x: [],
      y: [],
      marginx: [],
      marginy: [],
      margintx: [],
      marginty: [],
      drivers: [],
      suppositions: [],
      actors: [],
      scale: [],
      otherRisksRelated: [],
      otherOppsRelated: [],
      risk: [null],  // new control for selected risk
      opportunity: [null],  // new control for selected opportunity
      tier3Relations: this.fb.array([]),  // this will hold the selected risks and opportunities
      selectedRisks: this.fb.array([]),
      selectedRisk: [''],
      selectedOpps: this.fb.array([]),
      selectedOpp: [''],
      isActive: [false],
      isNT3: [false],
      reviewedBy: [''],
      touchedBy: ['']
    })
  }

  addRisk() {
    const selectedRisk = this.formT3.get('selectedRisk').value;
    if (selectedRisk) {
      const selectedRisks = this.formT3.get('selectedRisks') as FormArray;
      selectedRisks.push(this.fb.group({
        idtier3related: selectedRisk.id,
        code: selectedRisk.code,
        shorttitle: selectedRisk.shorttitle,
      }));
    }
  }

  addOpp() {
    const selectedOpp = this.formT3.get('selectedOpp').value;
    if (selectedOpp) {
      const selectedOpps = this.formT3.get('selectedOpps') as FormArray;
      selectedOpps.push(this.fb.group({
        idtier3related: selectedOpp.id,
        code: selectedOpp.code,
        shorttitle: selectedOpp.shorttitle,
      }));
    }
  }

  removeRisk(index: number) {
    const selectedRisks = this.formT3.get('selectedRisks') as FormArray;
    selectedRisks.removeAt(index);
  }

  getRiskTitle(riskControl) {
    const risk = this.risks.find(risk => risk.id === riskControl.value);
    return risk ? risk.shorttitle : '';
  }

  get selectedRisksControls() {
    return this.formT3.get('selectedRisks') as FormArray;
  }

  addOpportunity() {
    const selectedOpp = this.formT3.get('selectedOpp').value;
    if (selectedOpp) {
      const selectedOpps = this.formT3.get('selectedOpps') as FormArray;
      selectedOpps.push(this.fb.group({
        idtier3related: selectedOpp.id,
        code: selectedOpp.code,
        shorttitle: selectedOpp.shorttitle,
      }));
    }
  }

  removeOpportunity(index: number) {
    const selectedOpps = this.formT3.get('selectedOpps') as FormArray;
    selectedOpps.removeAt(index);
  }

  getOppTitle(oppControl) {
    const opp = this.opportunities.find(opp => opp.id === oppControl.value);
    return opp ? opp.shorttitle : '';
  }

  get selectedOppsControls() {
    return this.formT3.get('selectedOpps') as FormArray;
  }

  getT3(params: any) {
    if (params.id) {
      this.tier3Service.getOne(params.id).subscribe(
        async ({ data }: ResponseOneTier3) => {
          this.t3 = data;
          this.getLog();
          this.verifiedImgDirectory();
          this.edit = true;
          this.loadData();
          if (this.t3) {
            this.getTier3Relations(params.id);
          }
        },
        err => { this.msg = this.errorService.handleError(err); }
      );
    } else if (params.idtier1) {
      this.idtier1 = params.idtier1;
      this.edit = false;
    }
  }

  verifiedImgDirectory() {
    if (this.t3.img != null) {
      (this.t3.img.substring(1, 7) === 'upload') ? this.isUploadDir = true : this.isUploadDir = false;
    }
  }

  loadData() {
    this.formT3.reset(this.t3);
  }

  loadDataTier3Relations() {
    while ((this.formT3.get('selectedRisks') as FormArray).length !== 0) {
      (this.formT3.get('selectedRisks') as FormArray).removeAt(0);
    }

    // If there are selected risks in t3
    if (this.t3.selectedRisks && this.t3.selectedRisks.length > 0) {
      // Iterate over each selected risk in t3
      this.t3.selectedRisks.forEach((selectedRisk: Tier3Relations) => {
        // Create a form group for the selected risk with its initial values
        const selectedRiskFormGroup = this.fb.group({
          id: [selectedRisk.id],
          idtier3: [selectedRisk.idtier3],
          idtier3related: [selectedRisk.idtier3related],
          code: [selectedRisk.code],
          shorttitle: [selectedRisk.shorttitle],
          status: [selectedRisk.status],
        });
        // Add the form group to the selected risks form array
        (this.formT3.get('selectedRisks') as FormArray).push(selectedRiskFormGroup);
      });
    }
  }

  onUpload() {
    let formData = new FormData();
    formData.append("uploads", this.uploatedFile[0], this.uploatedFile[0].name);
    this.uploadS.uploadFile(formData).subscribe((res) => {
      this.filename = res['filename'];
      this.saveOrUpdate();
    });
  }

  onFileChange(e) {
    this.uploatedFile = e.target.files;
    const reader = new FileReader();
    reader.onload = (e) => {
      this.formT3.get('img').setValue(e.target['result']);
    };
    reader.readAsDataURL(this.uploatedFile[0]);
  }

  save() {
    if (this.formT3.invalid) {
      return Object.values(this.formT3.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      (this.uploatedFile != null) ? this.onUpload() : this.saveOrUpdate();
    }
  }

  saveOrUpdate() {
    this.edit ? this.update(this.formT3.value.id, this.formT3.value) : this.create(this.formT3.value);
    this.router.navigate(['/adm/evento/list']);
  }

  dataLog = {};
  create(t3: Tier3) {
    delete t3.id;
    t3.idtier1 = +this.idtier1;
    if (this.filename) { t3.img = '/uploads/' + this.filename; }
    this.tier3Service.create(t3).subscribe({
      next: res => {
        if (res) {
          this.createRelations(res['data'].id, 'selectedRisks');
          this.createRelations(res['data'].id, 'selectedOpps');
          this.createNewSection(res['data'].id);
          this.utilLogservice.createLog(res['data'], 'creación', 'Lista eventos');
        }
      },
      error: err => { console.error(err) }
    });
  }

  createRelations(newId: number, controlName: string) {
    let id_event: number = null;
    if (controlName == 'selectedRisks') {
      id_event = this.idRisk;
    } else if (controlName == 'selectedOpps') {
      id_event = this.idOpportunity;
    }
    // Guardar todas las relaciones de riesgo.
    const selectedRelations: Tier3Relations[] = this.formT3.get(controlName).value;
    for (let relation of selectedRelations) {
      // Establecer el ID Tier3.
      relation.idtier3 = newId;
      relation.idtier1 = id_event;
      this.tier3RelationsService.create(relation).subscribe({
        next: res => console.log("relation created: ", res),
        error: err => console.error(err)
      });
    }
  }

  update(id: string, t3: Tier3) {
    const data = { ...t3 };
    delete t3.id;
    if (this.filename) { t3.img = '/uploads/' + this.filename; }
    this.tier3Service.update(id, t3).subscribe({
      next: res => {
        if (res) {
          this.updateRelations(id, 'selectedRisks');
          this.updateRelations(id, 'selectedOpps');
          this.utilLogservice.createLog(data, 'edición', 'Lista eventos');
        }
      },
      error: err => { console.error(err) }
    });
  }

  updateRelations(id: string, controlName: string) {
    let id_event: number = null;
    if (controlName == 'selectedRisks') {
      id_event = this.idRisk;
    } else if (controlName == 'selectedOpps') {
      id_event = this.idOpportunity;
    }
    this.tier3RelationsService.deleteByTier3(+id, id_event).subscribe({
      next: delRes => {
        const selectedRelations: Tier3Relations[] = this.formT3.get(controlName).value;
        for (let relation of selectedRelations) {
          relation.idtier3 = +id;
          relation.idtier1 = id_event;
          this.tier3RelationsService.create(relation).subscribe({
            next: res => console.log("relation created: ", res),
            error: err => console.error(err)
          });
        }
      },
      error: delErr => { console.error(delErr) }
    });
  }

  campoNoValido(campo: string) {
    return this.formT3.get(campo).invalid && this.formT3.get(campo).touched;
  }

  /* Cargar data de tematic para el combo */
  getTematics() {
    this.tematicsService.getAll().subscribe({
      next: async ({ data }: any) => { this.tematics = data; },
      error: err => { this.msg = this.errorService.handleError(err); }
    });
  }

  triggerDeleteRiskConfirmation(i: number) {
    this.riskToDelete = i;
    this.showDeleteConfirmationRisk = true;
  }

  triggerDeleteOppConfirmation(i: number) {
    this.oppToDelete = i;
    this.showDeleteConfirmationOpp = true;
  }

  confirmDeleteRisk() {
    this.selectedRisksControls.removeAt(this.riskToDelete);
    this.showDeleteConfirmationRisk = false;
  }

  cancelDeleteRisk() {
    this.showDeleteConfirmationRisk = false;
  }

  confirmDeleteOpp() {
    this.selectedOppsControls.removeAt(this.oppToDelete);
    this.showDeleteConfirmationOpp = false;
  }

  cancelDeleteOpp() {
    this.showDeleteConfirmationOpp = false;
  }

  /* Creamos una seccion como minimo con los valores por defecto*/
  section: Section = {
    id: null,
    idtier3: null,
    ideditor: null,
    order: 1,
    title: '',
    content: '',
    status: true,
    code: ''
  };

  createNewSection(idT3: number) {
    this.section.idtier3 = idT3;
    this.secS.create(this.section).subscribe(
      res => console.log("res create: ", res),
      err => console.error(err))
  }

  getLog() {
    const term = this.activedRoute.snapshot['_routerState'].url.split('/')[2];
    const idContent = this.activedRoute.snapshot.params['id'];
    this.userLogService.getLastLogByContent(idContent, term).subscribe(
      res => { this.movesLog = res['data'] || []; },
      err => console.error(err)
    );
  }
  //Validamos el codigo de la ficha//
  statusFieldDisabled: boolean = false;
  statusFieldVisible: boolean = true;
  validateCode(): void {
    const code = this.formT3.get('code').value;

    if (!code) {
      this.codeValidationMessage = 'El campo Código no puede estar vacío.';
      return;
    }

    this.tier3Service.validateCode(code).subscribe(
      response => {
        if (response['exists']) {
          this.formT3.get('version').setValue(response['suggestedVersion']);
          this.formT3.get('isActive').setValue(false);
          this.formT3.get('isNT3').setValue(false);
          this.formT3.get('status').setValue(false);

          this.statusFieldDisabled = true;
          this.statusFieldVisible = false;

          this.codeValidationMessage = response['message'];
        } else {
          this.formT3.get('version').setValue(1);
          this.formT3.get('isActive').setValue(true);
          this.formT3.get('isNT3').setValue(true);

          this.statusFieldDisabled = false;
          this.statusFieldVisible = true;

          this.codeValidationMessage = response['message'];
        }
      },
      error => {
        console.error('Error en la validación del código:', error);
        this.codeValidationMessage = 'Ocurrió un error al validar el código.';
      }
    );
  }
}
